/**
 * Help Center Content — Russian
 *
 * Экспортирует все категории и статьи для русской локализации
 */

// Categories
export { HELP_CATEGORIES_RU, getCategoryByIdRu } from "./categories";

// Articles
export { GETTING_STARTED_ARTICLES_RU } from "./articles/getting-started";
export { ACCOUNT_ARTICLES_RU } from "./articles/account";
export { DEPOSITS_ARTICLES_RU } from "./articles/deposits";
export { WITHDRAWALS_ARTICLES_RU } from "./articles/withdrawals";
export { TRANSACTIONS_ARTICLES_RU } from "./articles/transactions";
export { LIMITS_FEES_ARTICLES_RU } from "./articles/limits-fees";
export { SECURITY_ARTICLES_RU } from "./articles/security";
export { TROUBLESHOOTING_ARTICLES_RU } from "./articles/troubleshooting";

import type { HelpArticle, HelpCategory } from "../../types";

import { HELP_CATEGORIES_RU } from "./categories";
import { GETTING_STARTED_ARTICLES_RU } from "./articles/getting-started";
import { ACCOUNT_ARTICLES_RU } from "./articles/account";
import { DEPOSITS_ARTICLES_RU } from "./articles/deposits";
import { WITHDRAWALS_ARTICLES_RU } from "./articles/withdrawals";
import { TRANSACTIONS_ARTICLES_RU } from "./articles/transactions";
import { LIMITS_FEES_ARTICLES_RU } from "./articles/limits-fees";
import { SECURITY_ARTICLES_RU } from "./articles/security";
import { TROUBLESHOOTING_ARTICLES_RU } from "./articles/troubleshooting";

/**
 * All Russian articles combined
 */
export const ALL_ARTICLES_RU: HelpArticle[] = [
  ...GETTING_STARTED_ARTICLES_RU,
  ...ACCOUNT_ARTICLES_RU,
  ...DEPOSITS_ARTICLES_RU,
  ...WITHDRAWALS_ARTICLES_RU,
  ...TRANSACTIONS_ARTICLES_RU,
  ...LIMITS_FEES_ARTICLES_RU,
  ...SECURITY_ARTICLES_RU,
  ...TROUBLESHOOTING_ARTICLES_RU,
];

/**
 * Get articles by category (Russian)
 */
export function getArticlesByCategoryRu(categoryId: string): HelpArticle[] {
  return ALL_ARTICLES_RU.filter((article) => article.category === categoryId).sort(
    (a, b) => a.order - b.order
  );
}

/**
 * Get article by slug (Russian)
 */
export function getArticleBySlugRu(slug: string): HelpArticle | undefined {
  return ALL_ARTICLES_RU.find((article) => article.slug === slug);
}

/**
 * Get article by ID (Russian)
 */
export function getArticleByIdRu(id: string): HelpArticle | undefined {
  return ALL_ARTICLES_RU.find((article) => article.id === id);
}

/**
 * Get popular articles (Russian)
 */
export function getPopularArticlesRu(): HelpArticle[] {
  return ALL_ARTICLES_RU.filter((article) => article.popular);
}

/**
 * Search articles (Russian)
 */
export function searchArticlesRu(query: string): HelpArticle[] {
  const lowercaseQuery = query.toLowerCase();
  return ALL_ARTICLES_RU.filter(
    (article) =>
      article.title.toLowerCase().includes(lowercaseQuery) ||
      article.description.toLowerCase().includes(lowercaseQuery) ||
      article.keywords.some((keyword) =>
        keyword.toLowerCase().includes(lowercaseQuery)
      ) ||
      article.content.toLowerCase().includes(lowercaseQuery)
  );
}

/**
 * Get category with articles (Russian)
 */
export function getCategoryWithArticlesRu(
  categoryId: string
): { category: HelpCategory; articles: HelpArticle[] } | undefined {
  const category = HELP_CATEGORIES_RU.find((cat) => cat.id === categoryId);
  if (!category) return undefined;

  const articles = getArticlesByCategoryRu(categoryId);
  return { category, articles };
}
